import { FilterOptionLicense } from 'src/models/FilterMetric';
import FORMAT_QUERY_STRING from 'src/constants/dateFormatQueryString';
import { format, set } from 'date-fns';

type FilterMetricData = {
  filterLicenseSelected: FilterOptionLicense;
  filterSubagentSelected: FilterOptionLicense;
  isCheckedCurrentUserFilter: boolean;
};

const buildQueryFilterSalesTrend = (
  {
    filterLicenseSelected,
    filterSubagentSelected,
    isCheckedCurrentUserFilter,
  }: FilterMetricData,
  currentUser: string,
  loggedUserRole: string,
): string => {
  let query = '?';

  const startDateWithCustomTime = set(new Date(), {
    hours: 5,
    minutes: 0,
    seconds: 0,
  });

  const formatStartDate = format(startDateWithCustomTime, FORMAT_QUERY_STRING);

  // Filter date to query string
  query += `filter[where][updatedat][lte]=${formatStartDate}`;

  // add query filter with the license only if the user select a license ( license queryKey are empty or default)
  if (
    filterLicenseSelected.queryKey !== '' &&
    filterLicenseSelected.queryKey !== 'default'
  ) {
    query += `&filter[where][brokerlicense][in]=${filterLicenseSelected.queryKey}`;
  }

  // add query filter with subagent if any subagent has been selected
  if (filterSubagentSelected.queryKey !== '') {
    query += `&filter[where][agencyId][in]=${filterSubagentSelected.queryKey}`;
  }

  // If the user don't select any broker license, always fetch the quotations created by the current user only when user type is AGE
  if (
    (filterLicenseSelected.queryKey === '' ||
      filterLicenseSelected.queryKey === 'default') &&
    loggedUserRole === 'AGE'
  ) {
    query += `&filter[where][createdBy][in]=${currentUser}`;
  }

  // add to query string the filter created By only when the user type is ASE because user type AGE always sends the filter
  if (isCheckedCurrentUserFilter && loggedUserRole === 'ASE') {
    query += `&filter[where][createdBy][in]=${currentUser}`;
  }

  return query;
};

export default buildQueryFilterSalesTrend;
